import { useCallback, useState } from "react";
import {
  uploadSupportTicketAttachments,
  type ActiveStorageUpload,
} from "@/lib/storageUpload";
import type { TicketAttachmentCreate } from "@/services/supportTicketService";

export function useStorageUploadBatch() {
  const [activeUpload, setActiveUpload] = useState<ActiveStorageUpload | null>(
    null,
  );

  const uploadTicketAttachments = useCallback(
    async (entityId: string, files: File[]): Promise<TicketAttachmentCreate[]> => {
      if (files.length === 0) {
        return [];
      }
      try {
        return await uploadSupportTicketAttachments(
          entityId,
          files,
          setActiveUpload,
        );
      } finally {
        setActiveUpload(null);
      }
    },
    [],
  );

  return { activeUpload, uploadTicketAttachments };
}
